"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const lodash_1 = require("lodash");
const constants_1 = require("../constants");
const api_1 = require("../api");
const LoadingSpinner_1 = require("../shared/LoadingSpinner");
const react_bootstrap_1 = require("react-bootstrap");
const utils_1 = require("../utils");
const FontAwesome = require("react-fontawesome");
class SaveHistory extends React.Component {
    constructor(props) {
        super(props);
        this.email = '';
        this.confirmEmail = '';
        this.state = {
            state: constants_1.ProgressState.Loading,
            customerId: '',
            customer: null,
            emailsFieldErrorText: '',
            emailsFieldError: false,
            emailsFieldSuccess: false
        };
    }
    componentWillMount() {
        this.setState({
            state: constants_1.ProgressState.Success
        });
    }
    render() {
        let content;
        switch (this.state.state) {
            case constants_1.ProgressState.Loading:
                content = React.createElement(LoadingSpinner_1.default, { key: "SaveHistoryLoadingSpinner" });
                break;
            case constants_1.ProgressState.Success:
                content = this.renderSocialInfo();
                break;
            case constants_1.ProgressState.None:
                lodash_1.delay(() => this.setState({ state: constants_1.ProgressState.Success }), 10);
                break;
            default:
                break;
        }
        return React.createElement("div", null, content);
    }
    componentDidUpdate() {
        $('[data-toggle="popover"]').popover({
            trigger: 'focus'
        });
    }
    saveEmail() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.email === '' || this.confirmEmail === '') {
                    return this.setState({
                        emailsFieldError: true,
                        emailsFieldErrorText: 'Please fill both email fields'
                    });
                }
                if (this.email !== this.confirmEmail) {
                    return this.setState({
                        emailsFieldError: true,
                        emailsFieldErrorText: 'Provided emails are not same'
                    });
                }
                if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
                    yield api_1.doPost(api_1.API.v1.CUSTOMERS.SEND_HISTORY, {
                        //@ts-ignore
                        temporaryToken: this.props.location.query.token.replaceAll('*', '.'),
                        email: this.email
                    });
                    return this.setState({
                        emailsFieldSuccess: true
                    });
                } else {
                    return this.setState({
                        emailsFieldError: true,
                        emailsFieldErrorText: 'Provided emails are invalid'
                    });
                }
            } catch (err) {
                console.log(err);
            }
        });
    }
    renderSocialInfo() {
        return React.createElement("div", { className: `` }, React.createElement("div", { className: `zc_temp_header` }, "LoyalReach"), React.createElement("div", { className: `flex-center email-history_cont` }, !this.state.emailsFieldSuccess && React.createElement(react_bootstrap_1.Col, { xs: 12, sm: 6, lg: 6 }, React.createElement("div", { className: `eh_main_title` }, "Type your email to receive history of your communication "), React.createElement(react_bootstrap_1.Col, { xs: 12, lg: 12, className: `center-all eh_input_main` }, React.createElement(react_bootstrap_1.FormControl, { className: `eh_input`, name: "email", type: "text", placeholder: "Enter your email", onChange: event => utils_1.FormUtils.dataChanged(event, this) })), React.createElement(react_bootstrap_1.Col, { xs: 12, lg: 12, className: `center-all eh_input_main` }, React.createElement(react_bootstrap_1.FormControl, { className: `eh_input`, name: "confirmEmail", type: "text", placeholder: "Confirm your email", onChange: event => utils_1.FormUtils.dataChanged(event, this) })), this.state.emailsFieldError && React.createElement("div", { className: `eh_main_error` }, this.state.emailsFieldErrorText), React.createElement(react_bootstrap_1.Col, { xs: 12, lg: 12 }, React.createElement(react_bootstrap_1.Button, { bsStyle: "primary", title: "Save", onClick: () => this.saveEmail() }, this.state.state === constants_1.ProgressState.Loading && React.createElement(FontAwesome, { name: "spinner", spin: true, fixedWidth: true }), this.state.state !== constants_1.ProgressState.Loading && "save"))), this.state.emailsFieldSuccess && React.createElement(react_bootstrap_1.Col, { xs: 12, sm: 6, lg: 6 }, React.createElement("div", { className: `eh_main_success` }, "Messages history was sent to your provided email"))));
    }
}
exports.default = SaveHistory;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/SaveHistory.tsx
// module id = 1341
// module chunks = 0 1